var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocalTwo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 44s15-12 15-25c0-8.284-6.716-15-15-15S9 10.716 9 19c0 13 15 25 15 25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 25a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
}))));
export default SvgLocalTwo;